import { render, staticRenderFns } from "./wiapplicationform.vue?vue&type=template&id=12d0ef42"
import script from "./wiapplicationform.vue?vue&type=script&lang=js"
export * from "./wiapplicationform.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports